/**
 * How a billing term reads on screen.
 *
 * Anything the API sends gets a label — an unknown term is title-cased rather
 * than shown as "N/A". Two copies of this had already drifted: one listed
 * monthly, annual and free trial, so a quarterly subscription read as N/A on the
 * profile while the history tab showed it correctly.
 */
const KNOWN = {
  monthly: "Monthly",
  quarterly: "Quarterly",
  annual: "Annual",
  annualy: "Annual",
  annually: "Annual",
  yearly: "Annual",
  free_trial: "Free Trial",
};

export const planTypeLabel = (type) => {
  const raw = String(type ?? "").trim();
  if (!raw) return "N/A";
  const key = raw.toLowerCase().replace(/\s+/g, "_");
  return KNOWN[key] || raw.charAt(0).toUpperCase() + raw.slice(1);
};
